import { memo, useCallback } from "react";
import { OptionType, Security } from "../../../../proto/generated/security";
import { Box, Typography } from "@mui/material";
import { ExtraSmallButton } from "../../../custom";

export type SecurityTypeCellProps = {
    security: Security,
    disabled?: boolean,
    onChange: (optionType?: OptionType) => void
}

const SecurityTypeCell: React.FC<SecurityTypeCellProps> = ({security, disabled, onChange}) => {

    const onOptionTypeChange = useCallback(() => {
        onChange(security.optionType === OptionType.CE ? OptionType.PE : OptionType.CE);
    }, [onChange, security])

    return  <Box justifyContent="center" display="flex">
                {security.optionType ?
                <ExtraSmallButton variant="outlined"
                    style={{
                        height: '24px',
                        width: '32px',
                        padding: 0,
                        fontWeight: 400,
                        fontSize: '12px'
                    }}
                    disabled={disabled}
                    color={'inherit'}
                    data-event={'C/P Changed'}
                    data-event-source={'Trade'}
                    onClick={onOptionTypeChange}
                    >
                        {security.optionType === OptionType.CE ? "CE" : "PE"}
                </ExtraSmallButton> :
                <Typography sx={{ textAlign: 'center', width: '32px', fontSize: "12px" }}>FUT</Typography>}
            </Box>
}

export default memo(SecurityTypeCell);